import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ISyncExportRequest } from "@shared/lib/types/briefCampains";
import {
  PAYOUT_EXPORTS_QUERY_KEY,
  PAYOUTS_FACETS_QUERY_KEY,
  PAYOUTS_QUERY_KEY,
} from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useSyncPayoutExport() {
  const {
    mutate: syncPayoutExport,
    isLoading: isSyncing,
    isSuccess: isSynced,
  } = useMutation({
    mutationFn: async (request: ISyncExportRequest) => {
      return await CampaignService.syncVendorPaymentsExport(request).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    onSuccess: (client) => {
      ToastService.success("Bank statuses applied");
      setTimeout(() => {
        client.invalidateQueries({ queryKey: [...PAYOUTS_QUERY_KEY()] });
        client.invalidateQueries({ queryKey: [...PAYOUTS_FACETS_QUERY_KEY()] });
        client.invalidateQueries({ queryKey: [...PAYOUT_EXPORTS_QUERY_KEY()] });
      }, 1000);
    },
    options: { skipInvalidation: true },
  });

  return {
    syncPayoutExport,
    isSyncing,
    isSynced,
  };
}
